

















































import { Component, Vue } from 'vue-property-decorator'
import { getUser } from '@/store/userStore'
import router from '@/router'
import store from '@/store'
import RestPwdDialog from '@/views/platform/RestPwdDialog.vue'
import {LoginOut} from '@/api'

@Component({
  components: {
    RestPwdDialog
  }
})
export default class Header extends Vue {
  private username = getUser().userName
  private message = 0
  private get collapse() {
    return store.state.collapse
  }

  public created() {
    //   创建
  }
  public activated() {
    console.log('activated')
  }
  public mounted() {
    if (document.body.clientWidth < 1500) {
      this.collapseChage()
    }
  }

  public collapseChage() {
    store.commit('handleCollapse', !store.state.collapse)
  }
  public handleCommand(command: string) {
    if (command == 'loginout') {
      LoginOut().then((res:any) => {
        if(res){
          localStorage.removeItem('userInfo')
          store.commit('clearTags')
          router.push('/login')
        }
      })

    } else if (command == 'user') {
      router.push('/user')
    } else if (command == 'updatePwd') {
      // 修改密码
      const d = this.$refs.RestPwdDialog as any
      d.open({ id: getUser().user.id })
    }
  }
}
